import { render, staticRenderFns } from "./PC.vue?vue&type=template&id=07a4f8a1&scoped=true&"
import script from "./PC.vue?vue&type=script&lang=js&"
export * from "./PC.vue?vue&type=script&lang=js&"
import style0 from "./PC.vue?vue&type=style&index=0&lang=less&"
import style1 from "./PC.vue?vue&type=style&index=1&id=07a4f8a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a4f8a1",
  null
  
)

export default component.exports